export const TEACHER_NOT_FOUND_STRING = "Викладача не знайдено"
